<script>
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { verifyPasswordToken } from '../../../api/auth';
import { mapGetters } from 'vuex';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: { Spinner },
  props: {
    confirmationToken: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    loginBackgroundImage() {
      return this.globalConfig.loginBackgroundImage || null;
    },
    loginOverlayColor() {
      return this.globalConfig.loginOverlayColor || '#1f93ff';
    },
    loginOverlayOpacity() {
      const opacity = this.globalConfig.loginOverlayOpacity;
      return typeof opacity === 'number' ? opacity : 80;
    },
    backgroundStyle() {
      const defaultImage =
        'https://images.unsplash.com/photo-1557804506-669a67965ba0?q=80&w=2574&auto=format&fit=crop';
      const image = this.loginBackgroundImage || defaultImage;
      return {
        backgroundImage: `url('${image}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      };
    },
    overlayStyle() {
      const hex = this.loginOverlayColor.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const opacity = this.loginOverlayOpacity / 100;

      return {
        background: `linear-gradient(to top, rgba(${r}, ${g}, ${b}, ${opacity * 0.9}) 0%, rgba(${r}, ${g}, ${b}, ${opacity * 0.5}) 50%, transparent 100%)`,
      };
    },
  },
  mounted() {
    this.confirmToken();
  },
  methods: {
    async confirmToken() {
      try {
        await verifyPasswordToken({
          confirmationToken: this.confirmationToken,
        });
        window.location = DEFAULT_REDIRECT_URL;
      } catch (error) {
        window.location = DEFAULT_REDIRECT_URL;
      }
    },
  },
};
</script>

<template>
  <main class="relative min-h-screen w-full overflow-hidden">
    <!-- Fullscreen Background Image -->
    <div class="absolute inset-0" :style="backgroundStyle" />

    <!-- Configurable Overlay -->
    <div class="absolute inset-0" :style="overlayStyle" />

    <!-- Floating geometric shapes -->
    <div
      class="absolute top-20 left-20 w-72 h-72 bg-white/10 rounded-full blur-3xl animate-pulse hidden lg:block"
    />
    <div
      class="absolute bottom-20 right-20 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse delay-1000 hidden lg:block"
    />

    <!-- Main Content Container -->
    <div
      class="relative z-10 min-h-screen flex items-center justify-center py-8 px-4"
    >
      <!-- Card -->
      <div
        class="w-full max-w-sm bg-white/40 backdrop-blur-xl rounded-3xl border border-black/10 shadow-2xl p-8"
      >
        <!-- Logo -->
        <div class="mb-6 flex justify-center">
          <img
            :src="globalConfig.logo || '/logo.png'"
            :alt="globalConfig.installationName"
            class="w-auto h-10"
          />
        </div>

        <!-- Loading State -->
        <div class="flex flex-col items-center justify-center py-8">
          <Spinner size="large" />
          <p class="mt-4 text-slate-700 text-sm">{{ $t('CONFIRM_EMAIL') }}</p>
        </div>
      </div>
    </div>
  </main>
</template>
